
import { createContext, useState, useEffect } from 'react'
import axios from 'axios';
import { useNavigate } from 'react-router-dom'


interface Props {
  children: React.ReactNode;
}

export interface User {
  name: string;
  email: string;
  id: number;
  created_at: string;
  is_admin: boolean;
}

interface AuthContextProps {
  register: (formData: any) => void;
  login: (formData: any) => void;
  logout: () => void;
  currentUser: User | null;
}

const defaultContext: AuthContextProps = {
  register: () => {},
  login: () => {},
  logout: () => {},
  currentUser: null,
};


export const AuthContext = createContext<AuthContextProps>(defaultContext);

export const AuthContextProvider = ({ children }: Props ) => {
  const route = useNavigate();

  // save user to the localStorage
  const [currentUser, setCurrentUser] = useState<User | null>(() => {
    const storedUser = localStorage.getItem('gcad-user');
    return storedUser ? JSON.parse(storedUser) : null;
  });

  // save token to localStorage
  const [token, setToken] = useState<User | null>(() => {
    if (typeof window !== 'undefined') {
      const storeToken = localStorage.getItem('gcad-user-token');
  
      if (storeToken) {
        try {
          // Attempt to parse the storeToken, and set it to null if parsing fails
          return JSON.parse(storeToken) || null;
        } catch (error) {
          console.error('Error parsing user data:', error);
          return null;
        }
      } else {
        return null;
      }
    }
    return null;
  });

  // get the register axios from the login page
  const register = async (formData: any) => {
    const res = await axios.post(`${import.meta.env.VITE_SERVER_API}`, formData)
    
    console.log(res.data)
    setCurrentUser(res.data.user);
    setToken(res.data.access_token)

  }

  const login = async (formData: any) => {
    const res = await axios.post(`${import.meta.env.VITE_SERVER_API}/api/v1/admin/auth/login`, formData)
    
    setCurrentUser(res.data.data.user);
    setToken(res.data.data.token);
    route('/admin/dashboard')
    
  }

  const logout = async () => {
    try {
      // await api().post('/logout')
      
      setCurrentUser(null)
      setToken(null)
      route('/')

    } catch (error) {
      console.log(error)
    }
    
  }

  useEffect(() => {
    localStorage.setItem('gcad-user', JSON.stringify(currentUser))
    localStorage.setItem('gcad-user-token', JSON.stringify(token))
  }, [currentUser, token])

  return (
    <AuthContext.Provider value={{ login, logout, currentUser, register }}>
      {children}
    </AuthContext.Provider>
  )
}